import React from 'react';
import PropTypes from 'prop-types';
/* Utils */
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';

export function VerifyingScreenError({ isMatchingVIN = false, isPreVinFlow = false }) {
  return (
    <div data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'verifying' })}>
      <h4 className="size-20 mb-1 text-center fw-normal">Call Capital One to confirm your information.</h4>
      <div className="mb-2 d-flex flex-column align-items-center">
        <a className="size-20 text-primary-darker mb-0_5" href="tel:(866)311-1261">
          (866) 311-1261
        </a>
        <div className="size-14 mb-0_5">Mon-Fri 9am-9pm ET | Sat 10am-7pm ET</div>
      </div>
      <div className="d-flex justify-content-center mb-2">
        <p className="info-wrapper p-1 bg-gray-extra-light mb-0">
          To help protect your identity, Capital One needs a little more information. Please call the number above to
          complete your pre-qualification. Typically, you&apos;ll need to confirm your identity, residence, or
          employment.
        </p>
      </div>
    </div>
  );
}

VerifyingScreenError.propTypes = {
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
